import { createToaster } from '@chakra-ui/react'

export const toaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
  removeDelay: 1000,
})

export const useUserMessage = () => {
  const toastSuccess = (title: string, description?: string) => {
    toaster.create({
      duration: 10000,
      title,
      description,
      type: 'success',
      closable: true,
    })
  }

  const toastInfo = (title: string, description?: string) => {
    toaster.create({
      duration: 10000,
      title,
      description,
      type: 'info',
      closable: true,
    })
  }

  return {
    toastSuccess,
    toastInfo,
  }
}
